// Atlas Dashboard — Reports Page
// Lists and displays weekly/monthly reports.

import { FileText, Clock } from "lucide-react";
import { useReports } from "../hooks/useApi";
import { formatIstDate } from "../lib/format";

export function ReportsPage() {
  const { data, loading, error } = useReports();

  if (loading) return <div style={{ padding: "48px", textAlign: "center", color: "var(--color-text-tertiary)" }}>Loading reports...</div>;
  if (error) return <div style={{ padding: "48px", textAlign: "center", color: "#DC2626" }}>{error}</div>;
  if (!data || data.items.length === 0) return (
    <div style={{ padding: "48px", textAlign: "center", backgroundColor: "var(--color-card)", borderRadius: "8px", border: "1px solid var(--color-border)" }}>
      <FileText size={48} style={{ color: "var(--color-text-tertiary)", margin: "0 auto 16px" }} />
      <h3 style={{ fontSize: "16px", fontWeight: 600, marginBottom: "8px" }}>No reports yet</h3>
      <p style={{ color: "var(--color-text-secondary)", fontSize: "14px" }}>Your first weekly report will be generated automatically on Monday at 8:00 AM IST.</p>
    </div>
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      {data.items.map((report) => (
        <div key={report.reportId} style={{ backgroundColor: "var(--color-card)", borderRadius: "8px", border: "1px solid var(--color-border)", padding: "20px", cursor: "pointer", transition: "background 0.15s" }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F9FAFB")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "var(--color-card)")}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <FileText size={20} color="var(--color-text-tertiary)" />
              <div>
                <div style={{ fontSize: "15px", fontWeight: 600, color: "var(--color-text-primary)" }}>
                  {report.type === "weekly" ? "Weekly Report" : "Monthly Report"}
                </div>
                <div style={{ fontSize: "13px", color: "var(--color-text-secondary)" }}>
                  {formatIstDate(report.periodStart)} — {formatIstDate(report.periodEnd)}
                </div>
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "12px", color: "var(--color-text-tertiary)" }}>
              <Clock size={12} />
              {formatIstDate(report.generatedAt)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
